module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "شكر-وتقدير"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شكر وتقدير")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى عائلتي الغالية، وإلى رفاق دربي القرَّاء، وإلى وطني لبنان شعاع النورِ.. أرفع يدي وقلبي شكرًا وتقديرًا لكلِّ مَن ساهم في وُلوج هذا الكتاب إلى حيِّز الوجود.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إليكم أيها الأحبَّة رسالةَ شكرٍ مليئةً بالامتنان والعرفان.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشكُرُ عائلتي الحبيبة، وزوجي وأولادي على إعطائي الدعم والقوَّة للإبداع.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أودُّ أن أعبِّرَ عن شكري الخالص لكلِّ قُرَّائي الأعزَّاء، أنتم مَن منحتموني السرورَ والفخرَ بتقديم هذا العمل")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ولكلِّ مَن ساهم في هذا الكتاب، أسرة أوستن ماكولي، مِن محرِّرين وناقدين ومصمِّمين، أتوجَّه بكلِّ الامتنان لجهودكم المتميِّزة ومساهمتكم القَيِّمة")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في النهاية، أودُّ أن أمدَّ يدي بخالص الشكر والامتنان لدولة الإمارات العربية المتحدة، الأرض التي استقبلَتني بذراعين مفتوحتَين وكانت خلفيةً ملهمة لسعْيي الإبداعي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ثقافةُ الإمارات الحيويَّة وتراثُها الغني أثَّرا بشكل عميق في رحلتي ككاتبة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنا ممتنَّة لهذه الدولة الرائعة على الفرص التي منحَتها لي وعلى الضيافة الدافئة التي تلقَّيتُها مِن أهلها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دعمكم وتشجيعكم قد أثَّر في اشتعال شغفي بفنِّ الشعر والنثر والرواية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%",
      "height": "5.5in"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.jpg"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "width": "70%",
      "height": "6.5in"
    },
    attrs: {
      "alt": "",
      "src": "media/file2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A lawn with flowers and trees in front of a building Description automatically generated")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f588b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 72
// module chunks = 0